import { gql as apolloGql } from "@apollo/client";
import type { TypedDocumentNode } from "@apollo/client";

type AnyVariables = Record<string, unknown>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function gql<TData = any, TVariables extends AnyVariables = AnyVariables>(
  literals: string | readonly string[],
  ...args: unknown[]
): TypedDocumentNode<TData, TVariables> {
  return apolloGql(literals, ...args) as TypedDocumentNode<TData, TVariables>;
}
